module.exports = __webpack_public_path__ + "static/media/house_14.300ff1c3.jpg";